<app-i18n-dictionary>
    <span [attr.transid]="contactHrefSubjectTextId"
          i18n="@@contact-href-subject">Access for Hering Berlin B2B portal</span>
    <span [attr.transid]="contactHrefBodyTextId" i18n="@@contact-href-body">\n</span>
</app-i18n-dictionary>

<div class="apply">
    <div i18n="@@no-login">Problems with your login?</div>
    <div i18n="@@please-contact">Please contact: <a
        [href]="contactHref">info@heringberlin.com</a>
    </div>
</div>
